import { axiosInstanceReport } from "../axios";
import { EcommerceCards, RequestResponse } from "../types";

export const getEcommerceCardDetails = async (
  pageNumber: number,
  pageSize: number,
  startDate?: string,
  endDate?: string
): Promise<RequestResponse<{ records: EcommerceCards[]; total: number }>> => {
  try {
    const params = {
      pageNumber,
      pageSize,
      startDate,
      endDate
    };
    const response = await axiosInstanceReport.get(
      "/transactions/ecom/filter",
      {
        params
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data,
        total: response.data.count
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch mobile transactions: ", err);
    return {
      error: true,
      message: err.response.data?.errorMessage || err.message || err,
      data: null
    };
  }
};

export const downloadCSV = async (
  startDate: string,
  endDate: string,
  fileNumber: string
): Promise<{ data: Blob }> => {
  try {
    const response = await axiosInstanceReport.get(
      `/transactions/ecom/export/csv?startDate=${startDate}&endDate=${endDate}&fileNumber=${fileNumber}`,
      {
        responseType: "blob"
      }
    );
    console.log("response data", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("Error downloading CSV:", error);
    throw error;
  }
};
